export default {
    jobs_list(state){
        let temp = state.jobs_list
        return temp ? temp.response : null
    },
    current_work(state){
        let temp = state.current_work
        return temp ? temp : null
    },
    details_work(state){
        let temp = state.details_work
        return temp ? temp : null
    },
};